import { render } from "./individual_liveness_verification.html?vue&type=template&id=53322bec&external"
import script from "./individual_liveness_verification.js?vue&type=script&lang=js&external"
export * from "./individual_liveness_verification.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__